import {ProcessEngineerPlantDashboard} from '@features/process-engineer-dashboard'
import {SHIFT_QUICK_SELECT_SLOTS} from '@hconnect/common/types'
import {getHProduceMyTasksUrl} from '@hconnect/common/utils'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router'

import {
  ProcessEngineerEventName,
  useTrackProcessEngineerAnalyticsEvent
} from '../../../performanceDashboard/helpers'
import {useTranslationPrefix} from '../../../shared/hooks'
import {LocationBreadcrumbs} from '../../components'
import {
  generateCockpitShiftSummaryLink,
  getProcessEngineerPerformancePagePath,
  getProcessEngineerStoppageAnalysisPagePath
} from '../../utils'

type PathParameter = {
  plantId?: string
}

export const ProcessEngineerDashboard = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()
  const navigate = useNavigate()

  const redirectToStoppageAnalysis = (equipmentId: string) => {
    void navigate(getProcessEngineerStoppageAnalysisPagePath(plantId, equipmentId))
  }
  const shiftSummaryHref = generateCockpitShiftSummaryLink(SHIFT_QUICK_SELECT_SLOTS.Today, plantId)
  const plantStatusPageHref = getProcessEngineerPerformancePagePath(plantId, 'yesterday')
  const myTasksHref = getHProduceMyTasksUrl()

  const trackProcessEngineerDashboard = useTrackProcessEngineerAnalyticsEvent()
  useEffect(() => {
    trackProcessEngineerDashboard(ProcessEngineerEventName.UserEntersProcessEngineerDashboard, {})
  }, [trackProcessEngineerDashboard])

  return (
    <ProcessEngineerPlantDashboard
      plantId={plantId}
      shiftSummaryHref={shiftSummaryHref}
      myTasksHref={myTasksHref}
      plantStatusPageHref={plantStatusPageHref}
      onEquipmentClick={redirectToStoppageAnalysis}
      titleSlot={t(`${hrocPrefix}.processEngineerDashboard.pageTitle`)}
      aboveTitleSlot={<LocationBreadcrumbs />}
    />
  )
}
